<script>
import { tableRelevant } from "@/pages/projectImpl/js/utils";

export default {
  name: "quantityManage",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop: "visible",
    event: "close",
  },
  data() {
    return {
      seriesInfo: this.$store.getters["course/getSeriesInfo"](),
      step: 1,
      contentCount: undefined,
      confirmLoading: false,
      courseTypeList: [
        { value: 1, label: "测评课程" },
        { value: 2, label: "训练课程" },
        { value: 3, label: "活动课程" },
      ],
      searchForm: {
        CourseName: undefined,
        ChildCourseName: undefined,
        ChildCourseType: undefined,
        PeriodList: undefined,
        MinChildCourseDisplayOrder: undefined,
        MaxChildCourseDisplayOrder: undefined,
      },
      columns: [
        { title: "关联课程", dataIndex: "courseName" },
        { title: "课时排序", dataIndex: "childCourseDisplayOrder" },
        { title: "关联课时", dataIndex: "childCourseName" },
        { title: "内容数", dataIndex: "contentCount" },
      ],
      table: tableRelevant.call(this),
      table2: tableRelevant.call(this),
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.getPageList(1);
      }
    },
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.table.selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
          this.table.selectedRowKeys = selectedRowKeys;
          const list = this.table.selectedRows.concat(selectedRows);
          this.table.selectedRows = this.table.selectedRowKeys.map(m => {
            return list.find(f => f.childCourseId === m) || {};
          });
        },
      };
    },
  },
  methods: {
    getPageList(pageIndex) {
      const Params = {
        CourseSeriesId: this.seriesInfo.id,
        ComposeMode: 2, // 智能课
        pageIndex: pageIndex || this.table.tablePagination.current,
        pageSize: this.table.tablePagination.pageSize,
        ...this.searchForm,
      };
      this.table.tableLoading = true;
      this.$http.CourseResource.courseSessionSerie(Params).then(({ data }) => {
        this.table.tableDataSource = data.items.map(m => {
          m.courseName = m.courseName + " - " + m.period;
          return m;
        });
        this.table.tablePagination.total = data.totalCount;
        this.table.tablePagination.current = data.pageIndex;
        this.table.tablePagination.pageSize = data.pageSize;
      }).finally(() => {
        this.table.tableLoading = false;
      });
    },
    searchReset() {
      for (let searchFormKey in this.searchForm) {
        this.searchForm[searchFormKey] = undefined;
      }
      this.getPageList(1);
    },
    ok() {
      if (!this.contentCount) {
        this.$message.error("请输入内容数");
        return;
      }
      if (this.step <= 1) {
        if (this.table.selectedRowKeys.length) {
          this.step += 1;
          this.table.selectedRows = this.table.selectedRows.map(m => {
            const item = JSON.parse(JSON.stringify(m));
            item.contentCount = this.contentCount;
            return item;
          });
        } else {
          this.$message.error("请选择");
        }
        return;
      }

      const Params = {
        "courseSessionIds": this.table.selectedRowKeys,
        "contentCount": this.contentCount,
      };
      this.confirmLoading = true;
      this.$http.CourseResource.courseSessionSetCount(Params).then(res => {
        this.$message.success(res.message);
        this.close();
      }).finally(() => {
        this.confirmLoading = false;
      });
    },
    cancel() {
      if (this.step <= 1) {
        this.close();
        return;
      }
      this.step -= 1;
    },
    close() {
      this.$emit("close", false);
      for (let searchFormKey in this.searchForm) {
        this.searchForm[searchFormKey] = undefined;
      }
      this.step = 1;
      this.contentCount = undefined;
      this.table = tableRelevant.call(this);
    },
  },
};
</script>

<template>
  <a-modal centered :visible="visible"
           :confirm-loading="confirmLoading"
           :okText="step === 1 ? '下一步' : '确定'"
           :cancelText="step === 2 ? '上一步' : '取消'"
           :cancelButtonProps="{on: {click: cancel}}"
           @ok="ok"
           @cancel="close"
           :title="step === 1 ? '设置课时内容数' : '确认课程'" width="1100px">
    <p>仅对智能组合内容生效</p>
    <a-form-model v-show="step === 1" layout="inline" class="search-form">
      <a-form-model-item required label="内容数">
        <a-input-number v-model="contentCount" :min="1" :max="9999" :precision="0" allowClear placeholder="请输入" />
      </a-form-model-item>
    </a-form-model>
    <a-form-model v-show="step === 1" layout="inline" :model="searchForm" class="search-form">
      <a-form-model-item label="课程名称">
        <a-input :maxLength="30" allowClear v-model="searchForm.CourseName" placeholder="请输入" />
      </a-form-model-item>
      <a-form-model-item label="课程类型">
        <a-select v-model="searchForm.ChildCourseType" allowClear placeholder="请选择">
          <a-select-option v-for="item in courseTypeList" :value="item.value" :key="item.value">
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="学段">
        <a-select allowClear v-model="searchForm.PeriodList" placeholder="请选择">
          <a-select-option :value="item" :key="item" v-for="item in $data._period">
            {{ item }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="课时名称">
        <a-input :maxLength="30" allowClear v-model="searchForm.ChildCourseName" placeholder="请输入" />
      </a-form-model-item>
      <a-form-model-item label="课时排序">
        <div style="display: flex;align-items: center;">
          <a-input-number v-model="searchForm.MinChildCourseDisplayOrder" :min="0" :precision="0"
                          placeholder="最小值" />
          ~
          <a-input-number v-model="searchForm.MaxChildCourseDisplayOrder" :max="9999" :precision="0"
                          :min="searchForm.MinChildCourseDisplayOrder" placeholder="最大值" />
        </div>
      </a-form-model-item>
      <a-form-model-item>
        <a-button @click="getPageList(1)" type="primary" html-type="button"> 查询</a-button>
        <a-button @click="searchReset" style="margin-left: 10px"> 重置</a-button>
      </a-form-model-item>
    </a-form-model>
    <a-table v-show="step === 1" row-key="childCourseId"
             :row-selection="rowSelection"
             :columns="columns"
             :pagination="table.tablePagination"
             :loading="table.tableLoading"
             :data-source="table.tableDataSource">
    </a-table>
    <a-table v-show="step === 2" row-key="childCourseId"
             :columns="columns" :pagination="table2.tablePagination" :data-source="table.selectedRows">
    </a-table>
  </a-modal>
</template>

<style scoped lang="less">

</style>
